import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './styles/teo.css';
import './styles/app.css';
import '@fontsource-variable/inter';
import '@fontsource-variable/playfair-display';
import './styles/theme.css';
import { applyPrefs, storedDensity, storedTheme } from './lib/prefs';
import { App } from './App';

applyPrefs(storedTheme(), storedDensity()); // antes de pintar: sin destello al cargar en tema oscuro

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
